import { ofType, ActionsObservable } from 'redux-observable';
import { map, mergeMap, flatMap } from 'rxjs/operators';
import { from } from 'rxjs';
import { format } from 'one-util-date';

import {
    SETSELECTED,
    SETPATIENTSELECTED,
    NO_CHANGE,
    SET as PATIENTSET,
    RESET as PATIENTRESET
} from 'one-state-subject/src/types';

import {
    TransformInsuranceDetails,
    TransformFHIRDetails
} from './transform';

import {
    setAction as setInsuranceAction,
    selectAction as selectInsuranceAction,
    Insurance,
    resetAction
} from 'one-state-insurance';

import {
    addAction
} from 'one-state-error/src/actions';

import {
    ErrorObject
} from 'one-state-error/src/errorobject';

import {
    setAction as setSkeletonAction
} from 'one-state-skeleton';
import {
    Skeleton
} from 'one-model-local';

import {
    SET as IdentifierSet
    } from 'one-state-patientidentifiers/src/types'

import {
    setAction as setFHIRAction,
    resetAction as setFHIRReset
} from 'one-state-fhirinsurance';
import { Disposition } from 'one-model-local';
import { InvokeFinesseProxy } from '../../subject/src/index';

export const enum Types {
    INSURANCEDETAILS = 'one-state-insurance/set',
    STORE_DISPOSITION_CODE = "store-disposition-code",
}

const pushtoSetInsuranceDetails = (payload: any) => setInsuranceAction(payload);
const pushtoSetFHIR = (payload: any) => setFHIRAction(payload);
const pushSelectedInsuranceDataToState = (payload: any) => selectInsuranceAction(payload);
const pushToSkeleton = (payload: any) => setSkeletonAction(payload);
const pushToDisposition = (payload: any) => ({ type: Types.STORE_DISPOSITION_CODE, payload });
function calculateDates() {
    const currentDate = new Date();
  
      // Calculate one year older date
      currentDate.setFullYear(currentDate.getFullYear() - 1);
      currentDate.setHours(0, 0, 0, 0); // Set time to 00:00:00
  
      // Calculate two years later date
      const twoYearsLaterDate = new Date(currentDate);
      twoYearsLaterDate.setFullYear(twoYearsLaterDate.getFullYear() + 3);
      twoYearsLaterDate.setHours(0, 0, 0, 0); // Set time to 00:00:00
  
      return {
        oneYearOlder: currentDate.toLocaleDateString("en-US", { month: "2-digit", day: "2-digit", year: "numeric" }),
        twoYearsLater: twoYearsLaterDate.toLocaleDateString("en-US", { month: "2-digit", day: "2-digit", year: "numeric" })
      };
    
  }

export const fetchInsuranceDetailsFromEpic = (context: any) => (
    (action$: ActionsObservable<any>, state$: any) => {
        const errorTime = format(new Date(), 'LT');
        const errorDate = format(new Date(), 'LL');
        const { server,
            log,
            agentId,
            teamName,
            alertnotification,
            settings:
            {
                servers,
                epicendpoints: { insurance, searchID, apitoken },
                uisettings: {
                    dashboardapiconfig: {
                        insurance: insuranceApi
                    }
                },
                compatible: { consolidated_api_invocation, contact_center_type, finesse_proxy_service, send_epic_client_id },
            }
        } = context;
        const { locations = [] } = servers;
        return action$.pipe(
            consolidated_api_invocation ? ofType(NO_CHANGE) : ofType(SETSELECTED),
            mergeMap((action: any) => {
                /**
                 * @param dataresponse contains the patient request
                 */
                const dataresponse: any = action.payload;
                log.debug("one-epics", "getinsuranceDetailsEpic request", dataresponse);
                const getInsuranceDetails = (payload: any) => {
                    let headers = new Headers();
                    headers.set('Authorization', 'Basic ' + apitoken?.token);
                    if (send_epic_client_id) {
                        const epicClientId = state$?.value?.epicuserid?.agentuserid || "1";
                        headers.set('Epic-Client-ID', epicClientId);
                    }
                    const data = {
                        "RequestID": "",
                        "PatientID":
                        {
                            "ID": payload?.id,
                            "Type": searchID
                        },
                        "CoverageID": { "ID": "", "Type": "" }
                    }
                    let response;
                    if (finesse_proxy_service) {
                        response = InvokeFinesseProxy(insurance + "?EffectiveAfterDate=1/1/2013" + "&EffectiveBeforeDate=11/1/2015" + "&MoopDedOnly=false" + "&FullData=true",
                            data, apitoken, locations, log, 'POST', alertnotification, { 'Epic-Client-ID': epicClientId });

                    } else {
                        response = server.post({
                            path: insurance + "?EffectiveAfterDate="+calculateDates()['oneYearOlder'] + "&EffectiveBeforeDate="+calculateDates()['twoYearsLater'] + "&MoopDedOnly=false" + "&FullData=true",
                            data: data,
                            headers: headers
                        }).then((responsefound: any) => responsefound)
                            .catch((responseresult: any) => {
                                log.error(
                                    "ccw-gadget,getinsuranceDetailsEpic-epic",
                                    "fetch-getinsuranceDetails-EPIC", {
                                    responseresult
                                }
                                );
                                // SEND to ALERT snotificiton/NOCserver for errors
                                if (responseresult?.status === 0) {
                                    if (alertnotification?.isEnabled()) {
                                        var timestamp = new Date().toJSON();
                                        alertnotification.notify({
                                            "error_code": "930-31",
                                            "error_type": "SERVER_ERROR",
                                            "error_description": "Unable to reach active servers",
                                            "error_supertype": "SERVER_FAILS",
                                            "error_detail": "Unable to reach any of server for retring data ",
                                            "alert": "Yes",
                                            "timestamp": timestamp,
                                            "params": responseresult
                                        });
                                    }
                                }
                                let sourceerror: ErrorObject = {
                                    source: "Insurance",
                                    type: "error",
                                    status: responseresult?.status,
                                    erroritems: responseresult?.errors,
                                    error_date: errorDate,
                                    error_time: errorTime
                                };
                                return sourceerror;
                            })
                        log.debug("one-epics", "getinsuranceDetailsEpic response", response);
                    }
                    return from(response);
                }
                if (!insuranceApi) return []
                return getInsuranceDetails(dataresponse).pipe(
                    map(response => TransformInsuranceDetails(response, context))
                ).pipe(
                    flatMap(response => {
                        const actions: any = [
                            pushtoSetInsuranceDetails(response.insurancedata)
                        ];
                        let skeletoninsurance: Skeleton = {
                            insurance_skeleton: false
                        }
                        actions.push(pushToSkeleton(skeletoninsurance));
                        if (response.error) {
                            actions.push(addAction(response.error));
                            let disp: Disposition = { value: "1009" }
                            if (contact_center_type && contact_center_type === 'five9') {
                                let agentIdValue = sessionStorage.getItem("agentName");
                                let skillName = sessionStorage.getItem("skillName");
                                disp.meta00 = agentIdValue;
                                disp.meta01 = skillName;
                                disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                            }
                            else if(contact_center_type==="genesys"){
                                disp.meta00 = sessionStorage.getItem("name");
                                disp.meta01 = sessionStorage.getItem("agentName");
                              }
                              else if(contact_center_type==="twilio"){
                                disp.meta00 = sessionStorage.getItem("twilio_userid");
                                disp.meta01 = "";
                              }
                              else if(contact_center_type==="ringcentral"){
                                disp.meta00 = sessionStorage.getItem("ringcentral_agentName");
                                disp.meta01 = "";
                              }
                              else if(contact_center_type==="inContact"){
                                disp.meta00 = sessionStorage.getItem("agentName");
                                disp.meta01 = sessionStorage.getItem("Incontact_SkillName");
                              }
                              else if(contact_center_type==="vonage"){
                                disp.meta00 = sessionStorage.getItem("vonage_userid");
                                disp.meta01 = "";
                              }
                              else if(contact_center_type==="wxcc"){
                                disp.meta00 = sessionStorage.getItem("wxcc_agentId");
                                disp.meta01 = "";
                              } 
                              else if(contact_center_type==="intermedia"){
                                disp.meta00 = sessionStorage.getItem("agentName");
                                disp.meta01 = sessionStorage.getItem("intermedia_SkillName");
                              }
                             else {
                                disp.meta00 = agentId;
                                disp.meta01 = teamName;
                                disp.dial_list_uid = state$.value.choosecaller?.callId;
                            }
                            disp.meta02 = dataresponse?.id;
                            disp.meta03 = response?.error?.status;
                            disp.meta04 = response?.error?.erroritems[0]?.error_detail;
                            disp.meta05 = "Failed to fetch the Insurance information"
                            actions.push(pushToDisposition(disp));
                        } else {
                            let disp: Disposition = { value: "192" }
                            if (contact_center_type && contact_center_type === 'five9') {
                                let agentIdValue = sessionStorage.getItem("agentName");
                                let skillName = sessionStorage.getItem("skillName");
                                disp.meta00 = agentIdValue;
                                disp.meta01 = skillName;
                                disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                            }
                            else if(contact_center_type==="genesys"){
                                disp.meta00 = sessionStorage.getItem("name");
                                disp.meta01 = sessionStorage.getItem("agentName");
                              }
                              else if(contact_center_type==="twilio"){
                                disp.meta00 = sessionStorage.getItem("twilio_userid");
                                disp.meta01 = "";
                              }
                              else if(contact_center_type==="ringcentral"){
                                disp.meta00 = sessionStorage.getItem("ringcentral_agentName");
                                disp.meta01 = "";
                              }
                              else if(contact_center_type==="inContact"){
                                disp.meta00 = sessionStorage.getItem("agentName");
                                disp.meta01 = sessionStorage.getItem("Incontact_SkillName");
                              }
                              else if(contact_center_type==="vonage"){
                                disp.meta00 = sessionStorage.getItem("vonage_userid");
                                disp.meta01 = "";
                              }
                              else if(contact_center_type==="wxcc"){
                                disp.meta00 = sessionStorage.getItem("wxcc_agentId");
                                disp.meta01 = "";
                              }  
                              else if(contact_center_type==="intermedia"){
                                disp.meta00 = sessionStorage.getItem("agentName");
                                disp.meta01 = sessionStorage.getItem("intermedia_SkillName");
                              }
                            else {
                                disp.meta00 = agentId;
                                disp.meta01 = teamName;
                                disp.dial_list_uid = state$.value.choosecaller?.callId;
                            }
                            disp.meta02 = dataresponse?.id;
                            disp.meta03 = "Insurance details fetched successfuly"
                            actions.push(pushToDisposition(disp));
                        }
                        return actions;
                    })
                )
            })
        )
    }

);

export const fetchFHIRDetailsFromEpic = (context: any) => (
    (action$: ActionsObservable<any>) => {
        const errorTime = format(new Date(), 'LT');
        const errorDate = format(new Date(), 'LL');
        const { server,
            log,
            alertnotification,
            settings:
            {
                epicendpoints: { fhrcoverage, apitoken }
            }
        } = context;
        return action$.pipe(
            ofType(IdentifierSet),
            mergeMap((action: any) => {
                /**
                 * @param dataresponse contains the patient request
                 */
                const dataresponse: any = action.payload;
                let data = "",headersdata = "";
                log.debug("one-epics", "getfhirDetailsEpic request", dataresponse);
                const getFHIRDetails = (payload: any) => {

                    if(payload) {
                        payload?.forEach((identifierdata: any)=> {
                            data = identifierdata?.id ? identifierdata.id : "";
                            headersdata = identifierdata?.headertypeid ? identifierdata.headertypeid : "";
                        })
                    }

                    let headers = new Headers();
                    headers.set('Authorization', 'Basic ' + apitoken?.token);
                    let response = server.get({
                        path: fhrcoverage + "?patient_id=" + data + "&my_chartuser_id=" + headersdata,
                        headers: headers
                    }).then((responsefound: any) => responsefound)
                        .catch((responseresult: any) => {
                            log.error(
                                "ccw-gadget,getfhirDetailsEpic-epic",
                                "fetch-getfhirDetails-EPIC", {
                                responseresult
                            }
                            );
                            
                            let sourceerror: ErrorObject = {
                                source: "FHIR",
                                type: "error",
                                status: responseresult?.status,
                                erroritems: responseresult?.errors,
                                error_date: errorDate,
                                error_time: errorTime
                            };
                            return sourceerror;
                        })
                    log.debug("one-epics", "getFHIRDetailsEpic response", response);
                    return from(response);
                }
                return getFHIRDetails(dataresponse).pipe(
                    map(response => TransformFHIRDetails(response, context))
                ).pipe(
                    flatMap(response => {
                        const actions: any = [
                            pushtoSetFHIR(response.fhircoverage)
                        ];
                        let skeletoninsurance: Skeleton = {
                            insurance_skeleton: false
                        }
                        actions.push(pushToSkeleton(skeletoninsurance));
                        if (response.error) {
                            actions.push(addAction(response.error));
                        }
                        return actions;
                    })
                )
            })
        )
    }

);

/**
 * This function is used to push the default selected value
 * for insurance module.
 * @param context has logger etc.
 */
export const pushSelectedInsuranceData = (context: any) => (
    (action$: any, state$: any) => {
        const {
            log
        } = context;
        return action$.pipe(
            ofType(Types.INSURANCEDETAILS),
            mergeMap((action: any) => {
                /**
                 * @param dataresponse contains the request to select default insurance details
                 */
                let dataresponse = action.payload;
                const getRequest = (datares: any) => {
                    const insurance: Insurance[] = state$.value.insurancedetails?.values;
                    let selectedinsurance: string = "";
                    if (insurance?.length > 0) {
                        selectedinsurance = insurance[0].groupnumber;
                    }
                    log.debug("one-epics", "pushSelectedInsuranceData response", selectedinsurance);
                    return from([selectedinsurance]);
                }

                return getRequest(dataresponse).pipe(
                    map(response => pushSelectedInsuranceDataToState(response))
                )
            })

        )
    }
);

/**
 * Listen for component clear and intiate state clear for Insurance
 * @param context  contains logger which is used for logging
 */
export const clearInsuranceEpic = (context: any) => (
    (action$: any) => {
        const { log } = context;
        log.debug(
            "ccw-gadget, insurance-epic",
            "clear-insurance-epic", {
        });
        return action$.pipe(
            ofType(PATIENTSET, SETSELECTED, PATIENTRESET, SETPATIENTSELECTED),
            map(action => resetAction())
        )

    }
);

/**
 * Listen for component clear and intiate state clear for FHIR
 * @param context  contains logger which is used for logging
 */
export const clearFHIRInsuranceEpic = (context: any) => (
    (action$: any) => {
        const { log } = context;
        log.debug(
            "ccw-gadget, insurance-epic",
            "clear-fhirinsurance-epic", {
        });
        return action$.pipe(
            ofType(PATIENTSET, SETSELECTED, PATIENTRESET, SETPATIENTSELECTED),
            map(action => setFHIRReset())
        )

    }
);